export const actionType = {
    SET_PRODUCTS : 'SET_PRODUCTS' ,
    SET_USER : ' SET_USER',
    SET_ISAUTHORIZED : ' SET_ISAUTHORIZED'
}

const reducer = (state, action) => {
    switch(action.type){
        case actionType.SET_PRODUCTS:
            return {
                ...state,
                products : action.products,
            };
        case actionType.SET_USER:
            return {
                ...state,
                user : action.user,
            };
        case actionType.SET_ISAUTHORIZED:
            return {
                ...state,
                isAuthorized : action.isAuthorized,
            };
  
        default : 
        return state;
    }

}

export default reducer;